import React from "react";
import "./couponCard.scss";
import { Stack, Skeleton } from "@mui/material";

const CouponCardSkeleton = () => {
  return (
    <div className="coupon-card">
      <Stack spacing={1} className="transition">
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div style={{ width: "100%" }}>
            <Skeleton animation="wave">
              <div className="coupon-description">coupon-description</div>
            </Skeleton>

            <Skeleton animation="wave">
              <div className="min-order">Min. order amount is ₹1200.</div>
            </Skeleton>
          </div>
        </div>
        <div>
          <div className="coupon-code">
            <Skeleton animation="wave">
              <p>ABCD10</p>
            </Skeleton>
          </div>
          <Skeleton animation="wave">
            <div className="expire-date">Expiry: 31 Dec 2023</div>
          </Skeleton>
        </div>
      </Stack>
    </div>
  );
};

export default CouponCardSkeleton;
